import { FileType, TenantProfileGroup } from "../SalesAidModal";
import { ReactComponent as Delete } from "../../../../assets/icons/trash.svg";
import { ReactComponent as CheckRoundedGreen } from "../../../../assets/icons/check-rounded-green.svg";
import { bytesToKB } from "../helperFunc";
import { Loading } from "../../../../components/Loading/Loading";
import { SelectInput } from "../../../../components/SelectInput/SelectInput";
import { useMemo } from "react";
import { GroupTag } from "./GroupTag";
import { TextInput } from "../../../../components/TextInput";



export function ListItem({ file, onDelete, fileUploadingProgress, isLoading, onChange, groupOptions }: { file: FileType, onDelete: () => void, fileUploadingProgress: string, isLoading: boolean, onChange: (file: FileType) => void, groupOptions: TenantProfileGroup[] }) {
    const options = useMemo(() => groupOptions
        .filter(group => !file.groups.includes(group.key))
        .map(group => ({ label: group.name, value: group.key }) as { label: string; value: string }), [groupOptions, file.groups]);
    return (
        <div className="flex items-center gap-5">
            <div className="flex-1 flex flex-col gap-3 bg-gray-100 rounded-md">
                <div className="px-3.5 py-3 flex items-center justify-between bg-gray-201 rounded-t-[11px]">
                    <div className="flex items-center gap-2">
                        <CheckRoundedGreen className={`w-[15px] h-[15px] mt-1 ${fileUploadingProgress !== "completed" ? "[&_path]:fill-[#A7A7A7]" : ""}`} />
                        <div className="text-xs font-semibold text-[#1C1B18] truncate max-w-[275px]">{file.name}</div>
                        {isLoading && <div>
                            {fileUploadingProgress === "pending" && <div className="text-[11px] uppercase">Pending</div>}
                            {fileUploadingProgress === "failed" && <div className="text-[11px] uppercase">Failed</div>}
                            {fileUploadingProgress === "progress" && <div>
                                <Loading />
                            </div>}
                        </div>}
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="text-xs text-gray-701 font-semibold">{bytesToKB(file.file.size)}</span>
                        <button className="group" onClick={onDelete} disabled={isLoading}>
                            <Delete className="group-hover:[&_path]:stroke-[#FE3030]" />
                        </button>
                    </div>
                </div>
                <div className="p-3.5 flex flex-col gap-4">
                    <div className="grid gap-4 min-w-0" style={{ gridTemplateColumns: 'minmax(80px, 1fr) minmax(80px, 1fr)' }}>
                        <div className="flex flex-col gap-1.5">
                            <span className="text-xs font-semibold text-black-600">COHORT</span>
                            <SelectInput
                                options={options}
                                value={""}
                                onChange={(e) => onChange({ ...file, groups: [...file.groups, e.target.value] })}
                                placeholder="Select Cohort"
                                className="!h-8 !border-0 !text-xs"
                            />
                        </div>

                        <div className="flex flex-col gap-1.5">
                            <span className="text-xs font-semibold text-black-600">DOC CODE</span>
                            <TextInput className="!h-8 !py-2 !px-2 !text-xs !border-0 !text-gray-601 !rounded-md !min-w-[80px]" placeholder="Code" value={file.code} onChange={(e) => onChange({ ...file, code: e.target.value })} />
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        {
                            file.groups.map(group => (
                                <GroupTag key={group} selectedGroup={groupOptions.find(g => g.key === group)} onRemove={() => onChange({ ...file, groups: file.groups.filter(g => g !== group) })} />
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
